import { useMemo } from 'react'
import { Group, Text } from '@common/ui'
import { diffLines } from 'diff'

const DiffStats = ({ left, right }: { left: string; right: string }) => {
  const { added, removed } = useMemo(() => {
    let added = 0
    let removed = 0
    for (const part of diffLines(left, right)) {
      if (part.added) added += part.count ?? 0
      else if (part.removed) removed += part.count ?? 0
    }
    return { added, removed }
  }, [left, right])

  return (
    <Group gap="xs">
      <Text size="xs" ff="monospace" fw={600} c="positive">
        +{added}
      </Text>
      <Text size="xs" ff="monospace" fw={600} c="negative">
        −{removed}
      </Text>
    </Group>
  )
}

export default DiffStats
